enum Actions {
  // action types
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  VERIFY_AUTH = "verifyAuth",
  LOGIN = "login",
  LOGOUT = "logout",
  REGISTER = "register",
  UPDATE_USER = "updateUser",
  FORGOT_PASSWORD = "forgotPassword",
  SET_BREADCRUMB_ACTION = "setBreadcrumbAction",
  SET_THEME_MODE_ACTION = "setThemeModeAction",
  //user
  USER_CREATE = "userCreate",
  USER_UPDATE = "userUpdate",

  //user group
  USER_GROUP_CREATE = "userGroupCreate",
  USER_GROUP_UPDATE = "userGroupUpdate",

  //permission
  PERMISSION_CREATE = "userCreate",
  PERMISSION_UPDATE = "userUpdate",

  //content.news
  NEWS_LIST = "newsList",
  NEW_CREATE = "newCreate",
  NEW_UPDATE = "newUpdate",
  NEW_DELETE = "newDelete",

  //content.video
  VIDEO_LIST = "videoList",
  VIDEO_DETAIL = "videoDetail",
  VIDEO_CREATE = "videoCreate",
  VIDEO_UPDATE = "videoUpdate",
  VIDEO_DELETE = "videoDelete",

  //notification
  NOTIFICATION_LIST = "notificationList",
  NOTIFICATION_CREATE = "notificationCreate",
  NOTIFICATION_DETAIL = "notificationDetail",
  NOTIFICATION_UPDATE = "notificationUpdate",
  NOTIFICATION_DELETE = "notificationDelete",

  // new_notification
  NEW_NOTIFICATION_LIST = "newNotificationList",

  //display.banner
  BANNER_CREATE = "bannerCreate",
  BANNER_UPDATE = "bannerUpdate",

  //publications.publications
  PUBLICATIONS_MANAGES_LIST = "publicationsManagesList",
  PUBLICATIONS_MANAGE_DETAIL = "publicationsManagesDetail",
  PUBLICATIONS_MANAGE_CREATE = "publicationsManageCreate",
  PUBLICATIONS_MANAGE_UPDATE = "publicationsManageUpdate",
  PUBLICATIONS_MANAGE_DELETE = "publicationsManageDelete",

  //publications.report-ktxhs
  REPORT_KTXHS_LIST = "reportKtxhsList",
  REPORT_KTXH_DETAIL = "reportKtxhDetail",
  REPORT_KTXH_CREATE = "reportKtxhCreate",
  REPORT_KTXH_UPDATE = "reportKtxhUpdate",
  REPORT_KTXH_DELETE = "reportKtxhDelete",
  REPORT_KTXHT_UPDATE_STATUS = "reportKtxhUpdateStatus",

  //che do bao cao
  CHEDO_BAOCAO_LIST = "cheDoBaoCaoList",
  CHEDO_BAOCAO_DETAIL = "cheDoBaoCaoDetail",
  CHEDO_BAOCAO_CREATE = "cheDoBaoCaoCreate",
  CHEDO_BAOCAO_UPDATE = "cheDoBaoCaoUpdate",
  CHEDO_BAOCAO_DELETE = "cheDoBaoCaoDelete",

  //publications.type-publications
  TYPE_PUBLICATION_CREATE = "TypePublicationsCreate",
  TYPE_PUBLICATION_UPDATE = "TypePublicationsUpdate",

  //document.field-documents
  FIELD_DOCUMENTS_LIST = "fieldDocumentsList",
  FIELD_DOCUMENT_DETAIL = "fieldDocumentsDetail",
  FIELD_DOCUMENT_CREATE = "fieldDocumentCreate",
  FIELD_DOCUMENT_UPDATE = "fieldDocumentUpdate",
  FIELD_DOCUMENT_DELETE = "fieldDocumentDelete",

  //document.agency-issued-documents
  AGENCY_ISSUED_DOCUMENTS_LIST = "agencyIssuedDocumentsList",
  AGENCY_ISSUED_DOCUMENT_DETAIL = "agencyIssuedDocumentDetail",
  AGENCY_ISSUED_DOCUMENT_CREATE = "agencyIssuedDocumentCreate",
  AGENCY_ISSUED_DOCUMENT_UPDATE = "agencyIssuedDocumentUpdate",
  AGENCY_ISSUED_DOCUMENT_DELETE = "agencyIssuedDocumentDelete",

  //document
  DOCUMENTS_LIST = "documentsList",
  DOCUMENT_DETAIL = "documentDetail",
  DOCUMENT_CREATE = "documentCreate",
  DOCUMENT_UPDATE = "documentUpdate",
  DOCUMENT_DELETE = "documentDelete",
  TYPE_DOCUMENTS_LIST = "typeDocumentsList",
  TYPE_DOCUMENT_DETAIL = "typeDocumentDetail",
  TYPE_DOCUMENT_CREATE = "typeDocumentCreate",
  TYPE_DOCUMENT_UPDATE = "typeDocumentUpdate",
  TYPE_DOCUMENT_DELETE = "typeDocumentDelete",

  NEWS_CONTENTS_LIST = "newsContentsList",
  NEWS_CONTENT_CREATE = "newsContentCreate",
  NEWS_CONTENT_UPDATE = "newsContentUpdate",
  NEWS_CONTENT_DELETE = "newsContentDelete",
  NEWS_CONTENT_DETAIL = "newsContentDetail",
  NEWS_CONTENT_UPDATE_STATUS = "newsContentUpdateStatus",
  NEWS_CONTENT_SET_MENU = "newsContentSetMenu",

  //menu
  MENU_LIST = "menuList",
  MENU_DETAIL = "menuDetail",
  MENU_CREATE = "menuCreate",
  MENU_UPDATE = "menuUpdate",
  FUNCTION_LIST = "functionList",
  MENU_DELETE = "menuDelete",
  MENU_DRAGDROP = "menuDragdrop",

  //display.organizational-structure.leaders
  LEADERS_LIST = "leadersList",
  LEADER_DETAIL = "leaderDetail",
  LEADER_CREATE = "leaderCreate",
  LEADER_UPDATE = "leaderUpdate",
  LEADER_DELETE = "leaderDelete",
  LEADERS_LIST_SELECT = "leadersListSelect",

  //display.organizational-structure.departments
  DEPARTMENTS_LIST = "departmentsList",
  DEPARTMENT_DETAIL = "departmentDetail",
  DEPARTMENT_CREATE = "departmentCreate",
  DEPARTMENT_UPDATE = "departmentUpdate",
  DEPARTMENT_DELETE = "departmentDelete",

  //display.organizational-structure.positions
  POSITIONS_LIST = "positionsList",
  POSITION_DETAIL = "positionDetail",
  POSITION_UPDATE = "positionUpdate",
  POSITION_DELETE = "positionDelete",

  //yearbook.yearbook
  YEARBOOKS_LIST = "yearbooksList",
  YEARBOOK_DETAIL = "yearbooksDetail",
  YEARBOOK_CREATE = "yearbookCreate",
  YEARBOOK_UPDATE = "yearbookUpdate",
  YEARBOOK_DELETE = "yearbookDelete",

  //yearbook.target-yearbooks
  TARGET_YEARBOOKS_LIST = "targetYearbooksList",
  TARGET_YEARBOOK_DETAIL = "targetYearbookDetail",
  TARGET_YEARBOOK_CREATE = "targetYearbookCreate",
  TARGET_YEARBOOK_UPDATE = "targetYearbookUpdate",
  TARGET_YEARBOOK_DELETE = "targetYearbookDelete",

  //yearbook.category-yearbook
  CATEGORY_YEARBOOKS_LIST = "categoryYearbooksList",
  CATEGORY_YEARBOOK_DETAIL = "categoryYearbooksDetail",
  CATEGORY_YEARBOOK_CREATE = "categoryYearbookCreate",
  CATEGORY_YEARBOOK_UPDATE = "categoryYearbookUpdate",
  CATEGORY_YEARBOOK_DELETE = "categoryYearbookDelete",
  //document.type-documents
  TYPE_DOCUMENTS_CREATE = "TypeDocumentsCreate",
  TYPE_DOCUMENTS_UPDATE = "TypeDocumentsUpdate",

  //manager
  MANAGER_LIST = "ManagerList",
  MANAGER_UPSERT = "ManagerUpsert",
  MANAGER_DETAIL = "ManagerDetail",
  MANAGER_DELETE = "ManagerDelete",

  LIST_TYPE = "ListType",
  LIST_MENU = "ListMenu",
  //manager-group
  MANAGER_GROUP_LIST = "ManagerGroupList",
  MANAGER_GROUP_UPSERT = "ManagerGroupUpsert",
  MANAGER_GROUP_DETAIL = "ManagerGroupDetail",
  MANAGER_GROUP_DELETE = "ManagerGroupDelete",

  //role
  ROLE_LIST = "RoleList",
  ROLE_UPSERT = "RoleUpsert",
  ROLE_DETAIL = "RoleDetail",
  ROLE_DELETE = "RoleDelete",

  PERMISSION_LIST = "PermissionList",
  MEMBER_LIST_BY_ROLE = "MemberListByRole",
  DELETE_MEMBER_FROM_ROLE = "DeleteMemberFromRole",

  GENERAL_CONFIG = "GeneralConfig",
  GENERAL_CONFIG_UPDATE = "GeneralConfigUpdate",

  //feedback
  FEEDBACKS_LIST = "feedbacksList",
  FEEDBACK_DETAIL = "feedbackDetail",
  FEEDBACK_DELETE = "feedbackDelete",
  FEEDBACK_UPDATE_STATUS = "feedbackUpdateStatus",

  //yearbook.category-yearbook
  ACTIVITY_LOGSES_LIST = "activityLogsesList",
  EXPORT_ACTIVITY_LOGS_LIST = "exportActivityLogsList",

  //
  SIGNUP_SERVICE_LIST = "SignUpServiceList",
  SIGNUP_SERVICE_DETAIL = "SignUpServiceDetail",
  SIGNUP_SERVICE_DELETE = "SignUpServiceDelete",
  SIGNUP_SERVICE_UPSERT = "SignUpServiceUpsert",
  SIGNUP_SERVICE_CHANGE_STATUS = "SignUpServiceChangeStatus",

  STATISTICAL_SERVICE_LIST = "statisticalServiceList",
  STATISTICAL_SERVICE_DETAIL = "statisticalServiceDetail",
  STATISTICAL_SERVICE_DELETE = "statisticalServiceDelete",
  STATISTICAL_SERVICE_UPSERT = "statisticalServiceUpsert",

  //banner
  BANNER_LIST = "BannerList",
  BANNER_DETAIL = "BannerDetail",
  BANNER_UPSERT = "BannerUpsert",
  BANNER_DELETE = "BannerDelete",

  //stats.lichphobiens
  LICH_PHO_BIENS_LIST = "lichPhoBiensList",
  LICH_PHO_BIEN_DETAIL = "lichPhoBienDetail",
  LICH_PHO_BIEN_CREATE = "lichPhoBienCreate",
  LICH_PHO_BIEN_UPDATE = "lichPhoBienUpdate",
  LICH_PHO_BIEN_DELETE = "lichPhoBienDelete",
  LICH_PHO_BIEN_UPDATE_STATUS = "lichPhoBienUpdateStatus",

  CHANGE_PASSWORD = "ChangePassword",

  //stats.chitieuthongkes
  CHI_TIEU_THONG_KES_LIST = "chiTieuThongKesList",
  CHI_TIEU_THONG_KE_DETAIL = "chiTieuThongKeDetail",
  CHI_TIEU_THONG_KE_CREATE = "chiTieuThongKeCreate",
  CHI_TIEU_THONG_KE_UPDATE = "chiTieuThongKeUpdate",
  CHI_TIEU_THONG_KE_DELETE = "chiTieuThongKeDelete",
  //stats.baocaosltk
  BAO_CAO_SLTKS_LIST = "baoCaoSLTKsList",
  BAO_CAO_SLTK_DETAIL = "baoCaoSLTKDetail",
  BAO_CAO_SLTK_CREATE = "baoCaoSLTKCreate",
  BAO_CAO_SLTK_UPDATE = "baoCaoSLTKUpdate",
  BAO_CAO_SLTK_DELETE = "baoCaoSLTKDelete",
  BAO_CAO_SLTK_UPDATE_STATUS = "baoCaoSLTKUpdateStatus",
  //InternalDocument
  INTERNAL_DOCUMENTS_LIST = "InternalDocumentsList",
  INTERNAL_DOCUMENT_DETAIL = "InternalDocumentDetail",
  INTERNAL_DOCUMENT_UPDATE = "InternalDocumentUpdate",
  INTERNAL_DOCUMENT_CREATE = "InternalDocumentCreate",
  INTERNAL_DOCUMENT_DELETE = "InternalDocumentDelete",
  INTERNAL_DOCUMENT_BY_MANAGER_DETAIL = "InternalDocumentByManagerDetail",
  INTERNAL_DOCUMENTS_BY_MANAGER_LIST = "InternalDocumentsByManagerList",

  //internal.notification
  INTERNAL_NOTIFICATIONS_LIST = "internalNotificationsList",
  INTERNAL_NOTIFICATION_DETAIL = "internalNotificationDetail",
  INTERNAL_NOTIFICATION_CREATE = "internalNotificationCreate",
  INTERNAL_NOTIFICATION_UPDATE = "internalNotificationUpdate",
  INTERNAL_NOTIFICATION_DELETE = "internalNotificationDelete",
  INTERNAL_NOTIFICATION_BY_MANAGER_DETAIL = "internalNotificationByManagerDetail",
  INTERNAL_NOTIFICATIONS_BY_MANAGER_LIST = "internalNotificationsByManagerList",

  // Cuoc dieu tra
  FETCH_CUOC_DIEU_TRA_LIST = "fetchCuocDieuTraList",
  CUOC_DIEU_TRA_DETAIL = "cuocDieuTraDetail",
  CUOC_DIEU_TRA_CREATE = "cuocDieuTraCreate",
  CUOC_DIEU_TRA_UPDATE = "cuocDieuTraUpdate",
  CUOC_DIEU_TRA_DELETE = "cuocDieuTraDelete",
  FETCH_CUOC_DIEU_TRA_DETAIL = "fetchCuocDieuTraDetail",

  // Tien đo thu thap thong tin
  INFO_COLLECTION_PROGRESS_LIST = "infoCollectionProgressList",
  INFO_COLLECTION_PROGRESS_DETAIL = "infoCollectionProgressDetail",

  INFO_COLLECTION_PROGRESS_API = "infoCollectionProgressApi",

  //districts
  DISTRICTS_LIST = "districtsList",

  // cuoc dieu tra api
  CUOC_DIEU_TRA_API_LIST = "CuocDieuTraApiList",
  CUOC_DIEU_TRA_API_DETAIL = "cuocDieuTraApiDetail",
  CUOC_DIEU_TRA_API_CREATE = "cuocDieuTraApiCreate",
  CUOC_DIEU_TRA_API_UPDATE = "cuocDieuTraApiUpdate",
  CUOC_DIEU_TRA_API_DELETE = "CuocDieuTraApiDelete",

  // gis linh vuc dieu tra api
  GIS_LINH_VUC_DIEU_TRA_LIST = "gisLinhVucDieuTraList",
  GIS_LINH_VUC_DIEU_TRA_DETAIL = "gisLinhVucDieuTraDetail",
  GIS_LINH_VUC_DIEU_TRA_CREATE = "gisLinhVucDieuTraCreate",
  GIS_LINH_VUC_DIEU_TRA_UPDATE = "gisLinhVucDieuTraUpdate",
  GIS_LINH_VUC_DIEU_TRA_DELETE = "gisLinhVucDieuTraDelete",

  GIS_CONFIG = "GisConfig",
  GIS_CONFIG_UPDATE = "GisConfigUpdate",

  GIS_IMPORT = "GisImport",

  // khao sat
  SURVEYS_LIST = "surveysList",
  SURVEY_CREATE = "surveysCreate",
  SURVEY_UPDATE = "surveysUpdate",
  SURVEY_DELETE = "surveyDelete",
  SURVEY_DETAIL = "surveyDetail",
  SURVEY_RESULT = "surveyResult",
  SURVEY_LIST_RESULT = "surveyListResult",

  PHAN_TO_LIST = "PhanToList",
  PHAN_TO_DETAIL = "PhanToDetail",
  PHAN_TO_UPSERT = "PhanToUpsert",
  PHAN_TO_DELETE = "PhanToDelete",
  LINH_VUC_DIEU_TRA_LIST_DROPDOWN = "LinhVucDieuTraListDropdown",
  CUOC_DIEU_TRA_LIST_DROPDOWN = "CuocDieuTraListDropdown",
  DANH_MUC_CHI_TIEU_LIST_DROPDOWN = "DanhMucChiTieuListDropdown",

  //gis danh muc chi tieu
  DANHMUC_CHITIEU_LIST = "danhMucChiTieuList",
  DANHMUC_CHITIEU_DETAIL = "danhMucChiTieuDetail",
  DANHMUC_CHITIEU_CREATE = "danhMucChiTieuCreate",
  DANHMUC_CHITIEU_UPDATE = "danhMucChiTieuUpdate",
  DANHMUC_CHITIEU_DELETE = "danhMucChiTieuDelete",
  LINHVUC_DIEUTRA_DATA_SEARCH = "linhvucDieuTraDataSearch",
  CUOCDIEUTRA_DATA_SEARCH = "cuocDieuTraDataSearch",

  // commune
  COMMUNE_LIST = "communeList",
  COMMUNE_DETAIL = "communeDetail",
  COMMUNE_CREATE = "communeCreate",
  COMMUNE_UPDATE = "communeUpdate",
  COMMUNE_DELETE = "communeDelete",
  // gis dmtinh
  DM_TINH_LIST = "dmTinhList",
  DM_TINH_DETAIL = "dmTinhDetail",
  DM_TINH_CREATE = "dmTinhCreate",
  DM_TINH_UPDATE = "dmTinhUpdate",
  DM_TINH_DELETE = "dmTinhDelete",

  // gis dmhuyen
  DM_HUYEN_LIST = "dmHuyenList",
  DM_HUYEN_DETAIL = "dmHuyenDetail",
  DM_HUYEN_CREATE = "dmHuyenCreate",
  DM_HUYEN_UPDATE = "dmHuyenUpdate",
  DM_HUYEN_DELETE = "dmHuyenDelete",

  // cuoc dieu tra gis
  CUOC_DIEU_TRA_GIS_LIST = "cuocDieuTraGisList",
  CUOC_DIEU_TRA_GIS_DETAIL = "cuocDieuTraGisDetail",
  CUOC_DIEU_TRA_GIS_CREATE = "cuocDieuTraGisCreate",
  CUOC_DIEU_TRA_GIS_UPDATE = "cuocDieuTraGisUpdate",
  CUOC_DIEU_TRA_GIS_DELETE = "cuocDieuTraGisDelete",

  // cau hinh domain
  SUBSITE_CONFIG_LIST = "subsiteConfigList",
  SUBSITE_CONFIG_CREATE = "subsiteConfigCreate",
  SUBSITE_CONFIG_UPDATE = "subsiteConfigUpdate",
  SUBSITE_CONFIG_DELETE = "subsiteConfigDelete",
  SUBSITE_CONFIG_DETAIL = "subsiteConfigDetail",

  // website lien ket
  LINKED_WEBSITE_LIST = "linkedWebsiteList",
  LINKED_WEBSITE_DETAIL = "linkedWebsiteDetail",
  LINKED_WEBSITE_CREATE = "linkedWebsiteCreate",
  LINKED_WEBSITE_UPDATE = "linkedWebsiteUpdate",
  LINKED_WEBSITE_DELETE = "linkedWebsiteDelete",

  //stats.dulieuchitieu
  DU_LIEU_CHI_TIEUS_LIST = "duLieuChiTieusList",
  DU_LIEU_CHI_TIEU_DETAIL = "duLieuChiTieuDetail",
  DU_LIEU_CHI_TIEU_CREATE = "duLieuChiTieuCreate",
  DU_LIEU_CHI_TIEU_UPDATE = "duLieuChiTieuUpdate",
  DU_LIEU_CHI_TIEU_DELETE = "duLieuChiTieuDelete",

  //gioi thieu
  INTRODUCE_DETAIL = "introduceDetail",
  INTRODUCE_UPDATE = "introduceUpdate",

  //dieutrathongke
  DIEUTRATHONGKE_LIST = "DieutrathongkeList",
  DIEUTRATHONGKE_DETAIL = "DieutrathongkeDetail",
  DIEUTRATHONGKE_UPSERT = "DieutrathongkeUpsert",
  DIEUTRATHONGKE_DELETE = "DieutrathongkeDelete",
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  PURE_AUTH_AND_SET_ERROR = "pureAuthAndSetError",
  PURGE_AUTH = "logOut",
  SET_AUTH = "setAuth",
  SET_USER = "setUser",
  SET_PASSWORD = "setPassword",
  SET_ERROR = "setError",
  SET_BREADCRUMB_MUTATION = "setBreadcrumbMutation",
  SET_LAYOUT_CONFIG_PROPERTY = "setLayoutConfigProperty",
  NEWS_LIST_DATA = "newsListData",
  FIELD_DOCUMENTS_LIST_DATA = "fieldDocumentsListData",
  FIELD_DOCUMENT_DETAIL_DATA = "fieldDocumentDetailData",
  TYPE_DOCUMENTS_LIST_DATA = "typeDocumentsListData",
  TYPE_DOCUMENT_DETAIL_DATA = "typeDocumentDetailData",
  AGENCY_ISSUED_DOCUMENTS_LIST_DATA = "agencyIssuedDocumentsListData",
  AGENCY_ISSUED_DOCUMENT_DETAIL_DATA = "agencyIssuedDocumentDetailData",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",
  SET_THEME_MODE_MUTATION = "setThemeModeMutation",

  DOCUMENTS_LIST_DATA = "documentListData",
  DOCUMENT_DETAIL_DATA = "documentDetailData",
  LEADERS_LIST_DATA = "leadersListData",
  LEADER_DETAIL_DATA = "leaderDetailData",
  DEPARTMENTS_LIST_DATA = "departmentsListData",
  DEPARTMENT_DETAIL_DATA = "departmentDetailData",
  LEADERS_LIST_SELECT_DATA = "leadersListSelectData",

  POSITIONS_LIST_DATA = "positionsListData",
  POSITION_DETAIL_DATA = "positionDetailData",

  //Menu
  MENU_LIST_DATA = "menuListData",
  MENU_DETAIL_DATA = "menuDetailData",
  FUNCTION_LIST_DATA = "functionListlData",

  //News
  NEWS_CONTENTS_LIST_DATA = "newsContentsListData",
  NEWS_CONTENT_DETAIL_DATA = "newsContentDetailData",

  //Video
  VIDEOS_LIST_DATA = "videoListData",
  VIDEO_DETAIL_DATA = "videoDetailData",

  //Notification
  NOTIFICATIONS_LIST_DATA = "notificationListData",
  NOTIFICATION_DETAIL_DATA = "notificationDetailData",

  //New Notification
  NEW_NOTIFICATIONS_LIST_DATA = "newNotificationListData",

  //publications
  PUBLICATIONS_MANAGES_LIST_DATA = "publicationsManagesListData",
  PUBLICATIONS_MANAGE_DETAIL_DATA = "publicationsManageDetailData",

  //publications.report-ktxhs
  REPORT_KTXHS_LIST_DATA = "reportKtxhsListData",
  REPORT_KTXH_DETAIL_DATA = "reportKtxhDetailData",

  //chedo bao cao
  CHEDO_BAOCAO_LIST_DATA = "cheDoBaoCaoListData",
  CHEDO_BAOCAO_DETAIL_DATA = "cheDoBaoCaoDetailData",

  //yearbook
  YEARBOOKS_LIST_DATA = "yearbooksListData",
  YEARBOOK_DETAIL_DATA = "yearbookDetailData",

  TARGET_YEARBOOKS_LIST_LIST_DATA = "targetYearbooksListData",
  TARGET_YEARBOOKS_DETAIL_DATA = "targetYearbookDetailData",

  //category_yearbook
  CATEGORY_YEARBOOKS_LIST_DATA = "categoryYearbooksListData",
  CATEGORY_YEARBOOK_DETAIL_DATA = "categoryYearbookDetailData",
  MANAGER_LIST_DATA = "managerListData",
  MANAGER_DETAIL_DATA = "managerDetailData",

  MANAGER_GROUP_LIST_DATA = "managerGroupListData",
  MANAGER_GROUP_DETAIL_DATA = "managerGroupDetailData",

  LIST_TYPE_DATA = "listTypeData",
  LIST_MENU_DATA = "listMenuData",

  ROLE_LIST_DATA = "roleListData",
  ROLE_DETAIL_DATA = "roleDetailData",
  PERMISSION_LIST_DATA = "PermissionListData",
  MEMBER_LIST_BY_ROLE_DATA = "MemberListByRoleData",

  //config
  GENERAL_CONFIG_DATA = "generalConfigData",
  GENERAL_CONFIG_UPDATE_DATA = "generalConfigUpdateData",

  //feedback
  FEEDBACKS_LIST_DATA = "feedbackListData",
  FEEDBACK_DETAIL_DATA = "feedbackDetailData",

  //activity_logs
  ACTIVITY_LOGSES_LIST_DATA = "activityLogsListData",
  EXPORT_ACTIVITY_LOGS_LIST_DATA = "ExportActivityLogsListData",

  SIGNUP_SERVICE_LIST_DATA = "SignUpServiceListData",
  SIGNUP_SERVICE_DETAIL_DATA = "SignUpServiceDetailData",
  BANNER_LIST_DATA = "BannerListData",
  BANNER_DETAIL_DATA = "BannerDetailData",

  //stats.lichphobiens
  LICH_PHO_BIENS_LIST_DATA = "lichPhoBiensListData",
  LICH_PHO_BIEN_DETAIL_DATA = "lichPhoBienDetailData",

  //stats.chitieuthongkes
  CHI_TIEU_THONG_KES_LIST_DATA = "chiTieuThongKesListData",
  CHI_TIEU_THONG_KE_DETAIL_DATA = "chiTieuThongKeDetailData",

  //stats.baocaosltk
  BAO_CAO_SLTKS_LIST_DATA = "baoCaoSLTKsListData",
  BAO_CAO_SLTK_DETAIL_DATA = "baoCaoSLTKDetailData",
  STATISTICAL_SERVICE_LIST_DATA = "statisticalServiceListData",
  STATISTICAL_SERVICE_DETAIL_DATA = "statisticalServiceDetailData",
  //InternalDocument
  INTERNAL_DOCUMENTS_LIST_DATA = "internalDocumentListData",
  INTERNAL_DOCUMENT_DETAIL_DATA = "internalDocumentDetailData",
  INTERNAL_DOCUMENT_BY_MANAGER_DETAIL_DATA = "internalDocumentByManagerDetailData",
  INTERNAL_DOCUMENTS_BY_MANAGER_LIST_DATA = "internalDocumentByManagerListData",

  //internal.notification
  INTERNAL_NOTIFICATIONS_LIST_DATA = "internalNotificationsListData",
  INTERNAL_NOTIFICATION_DETAIL_DATA = "internalNotificationDetailData",
  INTERNAL_NOTIFICATION_BY_MANAGER_DETAIL_DATA = "internalNotificationByManagerDetailData",
  INTERNAL_NOTIFICATIONS_BY_MANAGER_LIST_DATA = "internalNotificationsByManagerListData",

  // Cuoc dieu tra
  SET_CUOC_DIEU_TRA_LIST = "setCuocDieuTraList",
  SET_CUOC_DIEU_TRA_DETAIL = "setCuocDieuTraDetail",

  // districts
  DISTRICTS_LIST_DATA = "districtsListData",

  // cuoc dieu tra api
  CUOC_DIEU_TRA_API_LIST_DATA = "CuocDieuTraApiListData",
  CUOC_DIEU_TRA_API_DETAIL_DATA = "cuocDieuTraApiDetailData",
  // Tien đo thu thap thong tin
  INFO_COLLECTION_PROGRESS_LIST_DATA = "infoCollectionProgressListData",
  INFO_COLLECTION_PROGRESS_DETAIL_DATA = "infoCollectionProgressDetailData",

  INFO_COLLECTION_PROGRESS_API_DATA = "infoCollectionProgressApiData",

  GIS_LINH_VUC_DIEU_TRA_LIST_DATA = "gisLinhVucDieuTraListData",
  GIS_LINH_VUC_DIEU_TRA_DETAIL_DATA = "gisLinhVucDieuTraDetailData",

  // gis config
  GIS_CONFIG_DATA = "gisConfigData",
  GIS_CONFIG_UPDATE_DATA = "gisConfigUpdateData",

  // khao sat
  SURVEYS_LIST_DATA = "surveyListData",
  SURVEYS_DETAIL_DATA = "surveyDetailData",
  SURVEY_RESULT_DATA = "SurveyResultData",
  SURVEY_LIST_RESULT_DATA = "surveyListResultData",
  PHAN_TO_LIST_DATA = "PhanToListData",
  LINH_VUC_DIEU_TRA_LIST_DROPDOWN_DATA = "LinhVucDieuTraListDropdownData",
  CUOC_DIEU_TRA_LIST_DROPDOWN_DATA = "CuocDieuTraListDropdownData",
  DANH_MUC_CHI_TIEU_LIST_DROPDOWN_DATA = "DanhMucChiTieuListDropdownData",
  PHAN_TO_DETAIL_DATA = "PhanToDetailData",

  //gis danh muc chi tieu
  DANHMUC_CHITIEU_LIST_DATA = "danhMucChiTieuListData",
  DANHMUC_CHITIEU_DETAIL_DATA = "danhMucChiTieuDetailData",
  LINHVUC_DIEUTRA_SEARCH_DATA = "linhVucDieuTraSearchData",
  CUOCDIEUTRA_SEARCH_DATA = "cuocDieuTraSearchData",

  //commune
  COMMUNES_LIST_DATA = "communesListData",
  COMMUNE_DETAIL_DATA = "communeDetailData",
  //gis dm tinh
  DM_TINH_LIST_DATA = "dmTinhListData",
  DM_TINH_DETAIL_DATA = "dmTinhDetailData",

  //gis dm huyen
  DM_HUYEN_LIST_DATA = "dmHuyenListData",
  DM_HUYEN_DETAIL_DATA = "dmHuyenDetailData",

  // cuoc dieu tra gis
  CUOC_DIEU_TRA_GISES_LIST_DATA = "cuocDieuTraGisesListData",
  CUOC_DIEU_TRA_GIS_DETAIL_DATA = "cuocDieuTraGisDetailData",

  SUBSITE_CONFIG_LIST_DATA = "subsiteConfigListData",
  SUBSITE_CONFIG_DETAIL_DATA = "subsiteConfigDetailData",

  // website lien ket
  LINKED_WEBSITE_LIST_DATA = "linkedWebsiteListData",
  LINKED_WEBSITE_DETAIL_DATA = "linkedWebsiteDetailData",

  // du lieu chi tieu thong ke
  DU_LIEU_CHI_TIEUS_LIST_DATA = "duLieuChiTieusListData",
  DU_LIEU_CHI_TIEU_DETAIL_DATA = "duLieuChiTieuDetailData",

  INTRODUCE_DETAIL_DATA = "introduceDetailData",

  // Dieutrathongke
  DIEUTRATHONGKE_LIST_DATA = "DieutrthongkeListData",
  DIEUTRATHONGKE_DETAIL_DATA = "DieutrthongkeDetailData",
}

export { Actions, Mutations };
